/**
 * Created by Kristy on 3/5/2018.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('followupTypes', {
                parent: 'masterData',
                url: '/followupTypes',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_REC_ADMINISTRATOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/masterData/followupTypes/followupTypes.html',
                        controller: 'MDFollowupTypesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('masterData');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
